import React from "react";

import LeftArrow from '../../themes/default/icons/Icon-leftarrow.svg';
import RightArrow from '../../themes/default/icons/Icon-rightarrow.svg';
import RotateLeft from '../../themes/default/icons/Icon-rotate-alt-left.svg';
import RotateRight from '../../themes/default/icons/Icon-rotate-alt-right.svg';
import ZoomIn from '../../themes/default/icons/Icon-zoomin.svg';
import ZoomOut from '../../themes/default/icons/Icon-zoomout.svg';


const IconsMap = {
    'datatype-string': 'convert-lowercase',
    'datatype-integer': 'custom-format',
    'datatype-decimal': 'decimal-increase',
    'datatype-datetime': 'calendar-date',
    'datatype-boolean': 'checkbox-checked',
    'menu': 'menu',
    'left-arrow': LeftArrow,
    'right-arrow': RightArrow,
    'rotate-left': RotateLeft,
    'rotate-right': RotateRight,
    'zoom-in': ZoomIn,
    'zoom-out': ZoomOut
}

export default function MgyIcon({name, className,...rest}) {
    let iconKey = IconsMap[name];

    if (typeof iconKey === 'undefined') iconKey = name;

    if (iconKey.indexOf('.svg') > -1) {
        return (
            <img src={iconKey} alt={"X"}/>
        );
    }

    return (
        <span className={"mgy-icon k-icon k-i-" + (iconKey || name) + " " + (className ?? '')} {...rest} />
    );
}